import { render, staticRenderFns } from "./ProHomepageSubMenu.vue?vue&type=template&id=28e148cf&scoped=true"
import script from "./ProHomepageSubMenu.vue?vue&type=script&lang=js"
export * from "./ProHomepageSubMenu.vue?vue&type=script&lang=js"
import style0 from "./ProHomepageSubMenu.vue?vue&type=style&index=0&id=28e148cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e148cf",
  null
  
)

export default component.exports